module.exports = __webpack_public_path__ + "static/media/full-size.ad9281ea.svg";